import { graphql } from "gql";

const DOWNLOAD_URL_QUERY = graphql(`
  query DownloadUrl($fileId: ID!, $inline: Boolean) {
    downloadUrl(fileId: $fileId, inline: $inline)
  }
`);

export default DOWNLOAD_URL_QUERY;
